var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg7001276ClockHourTimeDurationTimerIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.13818C11.2107 1.13818 14.2188 4.14627 14.2188 7.85693C14.2188 11.5676 11.2107 14.5757 7.5 14.5757C3.78934 14.5757 0.78125 11.5676 0.78125 7.85693C0.78125 4.14627 3.78934 1.13818 7.5 1.13818ZM7.5 2.07568C4.3071 2.07568 1.71875 4.66404 1.71875 7.85693C1.71875 11.0498 4.3071 13.6382 7.5 13.6382C10.6929 13.6382 13.2812 11.0498 13.2812 7.85693C13.2812 4.66404 10.6929 2.07568 7.5 2.07568ZM7.5 3.38855C7.73731 3.38855 7.93343 3.5649 7.96447 3.79369L7.96875 3.8573V7.65631L10.3268 9.89922C10.4973 10.0614 10.5189 10.3214 10.3873 10.5082L10.3433 10.5619C10.1811 10.7324 9.9211 10.754 9.73426 10.6225L9.68057 10.5784L7.1769 8.19655C7.1025 8.12576 7.05392 8.03304 7.03747 7.93305L7.03125 7.85693V3.8573C7.03125 3.59842 7.24112 3.38855 7.5 3.38855Z",
    fill: "#3F2E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7001276ClockHourTimeDurationTimerIcon1);
export default __webpack_public_path__ + "static/media/7001276_clock_hour_time_duration_timer_icon 1.17295ff97b1a3271cad1cfbeb1cf4915.svg";
export { ForwardRef as ReactComponent };